import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

import IndGroupView from '../views/IndGroupView.vue';
import ProdDivView from '../views/ProdDivView.vue';
import ProductMainView from '../views/ProductMainView.vue';
import ProductDetailView from '../views/ProductDetailView.vue';
import ProductDetailDesc from '@/components/product/detail/ProductDetailDesc';
import CustomerInfo from '@/components/product/detail/CustomerInfo.vue';
import GroupInfo from '@/components/product/detail/GroupInfo.vue';
import PaymentView from '../views/PaymentView.vue';
import PaymentCompleteView from '../views/PaymentCompleteView.vue';
import CartView from '../views/CartView.vue';

import ReservationListView from '../views/ReservationListView.vue';
import ReservationDetailView from '../views/ReservationDetailView.vue';
import ReservationChangeView from '../views/ReservationChangeView.vue';
import ReservationCancelView from '../views/ReservationCancelView.vue';
import ReservationPaymentView from '../views/ReservationPaymentView.vue';

Vue.use(VueRouter);

const contextRoot = "/reserve";

const routes = [
  {
    path: '/ind',
    name: 'ind',
    component: ProdDivView,
  },
  {
    path: '/grp',
    name: 'grp',
    component: ProdDivView,
  },
  {
    path: '/ind/cart',
    name: 'ind_cart',
    component: CartView,
    meta: {
      requireAuth: true
   }
  },
  {
    path: '/grp/cart',
    name: 'grp_cart',
    component: CartView,
    meta: {
      requireAuth: true
   }
  },
  {
    path: '/ind/payment',
    name: 'Ind Payment',
    component: PaymentView,
    beforeEnter: (to, from, next) => {
      if(store.getters.bookingList?.length > 0){
        next();
      } else {
        alert('잘못된 접근 입니다.');
        next(false);
      }
    },
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/grp/payment',
    name: 'Grp Payment',
    component: PaymentView,
    beforeEnter: (to, from, next) => {
      if(store.getters.bookingList?.length > 0){
        next();
      } else {
        alert('잘못된 접근 입니다.');
        next(false);
      }
    },
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/ind/paymentCmpl/:bundleRvNo',
    name: 'Grp PaymentComplete',
    component: PaymentCompleteView,
    props: true,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/grp/paymentCmpl/:bundleRvNo',
    name: 'Ind PaymentComplete',
    component: PaymentCompleteView,
    props: true,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/ind/reservations',
    component: ReservationListView,
    meta: {
      requireAuth: true
   }
  },
  {
    path: '/grp/reservations',
    component: ReservationListView,
    meta: {
      requireAuth: true
   }
  },
  {
    path: '/ind/reservations/:bundleRvNo/',
    component: ReservationDetailView,
    meta: {
      requireAuth: true
   }
  },
  {
    path: '/grp/reservations/:bundleRvNo/',
    component: ReservationDetailView,
    meta: {
      requireAuth: true
   }
  },
  {
    path: '/ind/reservations/:bundleRvNo/change',
    component: ReservationChangeView,
    meta: {
      requireAuth: true
   }
  },
  {
    path: '/grp/reservations/:bundleRvNo/change',
    component: ReservationChangeView,
    meta: {
      requireAuth: true
   }
  },
  {
    path: '/ind/reservations/:bundleRvNo/cancel',
    component: ReservationCancelView,
    meta: {
      requireAuth: true
   }
  },
  {
    path: '/grp/reservations/:bundleRvNo/cancel',
    component: ReservationCancelView,
    meta: {
      requireAuth: true
   }
  },
  {
    path: '/grp/reservations/:bundleRvNo/payment',
    component: ReservationPaymentView,
    meta: {
      requireAuth: true
   }
  },
  {
    path: '/ind/:expDiv',
    name: 'Ind product list',
    component: ProductMainView,
  },
  {
    path: '/grp/:expDiv',
    name: 'Grp product list',
    component: ProductMainView,
  },
  {
    path: '/ind/:expDiv/:id',
    name: 'ind-detailView',
    component: ProductDetailView,
    children: [
      {
        name: 'Ind product detail desc',
        path: '',
        component: ProductDetailDesc,
        props: true,
      },
      {
        name: 'pcntInfo',
        path: 'reserve',
        component: CustomerInfo,
        meta: {
          reverse: true,
          requireAuth: true
       }
      },
    ]
  },
  {
    path: '/grp/:expDiv/:id',
    name: 'grp-detailView',
    component: ProductDetailView,
    children: [
      {
        name: 'Grp product detail desc',
        path: '',
        component: ProductDetailDesc,
        props: true,
      },
      {
        name: 'groupInfo',
        path: 'reserve',
        component: GroupInfo,
        meta: {
          reverse: true,
          requireAuth: true
       }
      },
    ]
  },


  {
    path: '/',
    name: 'IndGroup',
    component: IndGroupView,
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
];

routes.forEach((r, i) => {
  const path = r.path;
  let type = '';
  
  if (path.startsWith('/ind')) {
    type =  'ind';
  } else if (path.startsWith('/grp')) {
    type =  'grp';
  }

  if(r.meta) {
    r.meta.key = i;
    r.meta.type = type;
  } else {
    r.meta = {type}
  }

  if(r.children){
    r.children.forEach(c => {
      if(c.meta) {
        c.meta.key = i;
        c.meta.type = type;
      } else {
        c.meta = {type}
      }   
    })
  }
});

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) { 
    if(savedPosition){
      return savedPosition;
    } else {
      return { x: 0, y: 0 } 
    }
  },
  base: process.env.VUE_APP_BASE_URL,
  routes: routes,
});

router.beforeEach(async (to, from, next) => {
  //로그인이 필요한 화면은
  if (to.matched.some(record => record.meta.requireAuth)) {
    //기다려서 로그인 확인
    await store.dispatch('checkUserLogin');
    if (!store.getters.isLoggedIn) {
      sessionStorage.clear();
      customConfirm('로그인이 필요한 서비스 입니다. 로그인 하시겠습니까?', (confirm) => {
        if(confirm) {
          let domain = process.env.VUE_APP_API_DOMAIN ||  '';
          location.href = domain + '/login.do?menuId=109';
        }
      });
    } else {
      next();
    }
  } else {
    //로그인 필요 없는 화면은 기다리지 않음.
    store.dispatch('checkUserLogin');
    next();
  }
});




export default router;
